import { create } from 'zustand';
import { TUserStore } from '../types/user';
import { isLoggedIn } from '../utils/helper';
import { persistNSync } from 'persist-and-sync';

export const useUserStore = create<TUserStore>()(
  persistNSync(
    (set) => ({
      isLoggedIn: isLoggedIn(),
      user: null,
      setUser: (user) => set({ user }),
      logout: () => set({ isLoggedIn: false, user: null }),
      login: () => set({ isLoggedIn: true }),
    }),
    { name: 'user-persisted-store' }
  )
);
